var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUnder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.456,
    height: 16.971,
    viewBox: "0 0 25.456 16.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#e35d67;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3483.915 4657.005) rotate(-135)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 18,
    transform: "translate(5738.5 826.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 18,
    transform: "translate(5735.5 829.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnder);
export default __webpack_public_path__ + "static/media/icon_under.a3fb563097b1b53fcf20bb7e86a81d36.svg";
export { ForwardRef as ReactComponent };